export function fixTime(time) {
  let fixedTime = new Date(time);
  return fixedTime instanceof Date && !isNaN(fixedTime)
    ? fixedTime.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit"
      })
    : "N/A";
}

export function fixDate(date) {
  let fixedDate = new Date(date);

  return !isNaN(fixedDate.getTime())
    ? fixedDate.toLocaleDateString("en-US")
    : "N/A";
}

export function getDateString(date) {
  const dateObj = new Date(date);
  const day = dateObj.toLocaleDateString("en-US", { weekday: "long" }); // Wed
  return day;
}

export const studentId = window.student_id;

export const studentName = window.student_name;
